import { Tab, Tabs } from "react-bootstrap";
import { openPopup } from "../../../store/popupSlice";
import { useDispatch } from "react-redux";
import React from "react";

export default function OnDemandFeature({ data }) {
    const dispatch = useDispatch();
  return (
    <>
      <section className=" zip-feature-area cabify-feature-area ondemand-features">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="ondemand-feature-head">
                <h3 className="heading center-heading">{data?.preHead} <span className="gradiant-color"> {data && data.titlePart1}</span> {data && data.titlePart2}</h3>
                <p className="sub-heading">{data?.subHead}</p>
              </div>
            </div>

            <div className="col-lg-12">
              <Tabs defaultActiveKey="rider" id="uncontrolled-tab-example" className="mb-5">
                <Tab eventKey="rider" title="CUSTOMER APP">
                  <div className="zip-feature-body">
                    <div className="row align-items-center">
                      <div className="col-lg-4 text-right">
                        <div className="br-workflow-box">
                          <h3 className="heading">{data && data.feature1.title1}</h3>
                          <p>{data && data.feature1.description1}</p>
                        </div>
                        <div className="br-workflow-box">
                          <h3 className="heading">{data && data.feature1.title2}</h3>
                          <p>{data && data.feature1.description2}</p>
                        </div>
                        <div className="br-workflow-box">
                          <h3 className="heading">{data && data.feature1.title3}</h3>
                          <p>{data && data.feature1.description3}</p>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="br-img-animation">
                          <img className="img-responsive wow animate__animated animate__flipInY"  data-wow-duration="1s" src={data && data.feature1.image} alt="mobile" loading="lazy"/>
                          <div className="br-animate-box"></div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="br-workflow-box br-workflow-box-reverse">
                          <h3 className="heading">{data && data.feature1.title5}</h3>
                          <p>{data && data.feature1.description5}</p>
                        </div>
                        <div className="br-workflow-box br-workflow-box-reverse">
                          <h3 className="heading">{data && data.feature1.title6}</h3>
                          <p>{data && data.feature1.description6}</p>
                        </div>
                        <div className="br-workflow-box br-workflow-box-reverse">
                          <h3 className="heading">{data && data.feature1.title7}</h3>
                          <p>{data && data.feature1.description7}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>

                <Tab eventKey="driver" title="DRIVER APP">
                  <div className="zip-feature-body">
                    <div className="row align-items-center">
                      <div className="col-lg-4 text-right">
                        <div className="br-workflow-box">
                          <h3 className="heading">{data && data.feature2.title1}</h3>
                          <p>{data && data.feature2.description1}</p>
                        </div>
                        <div className="br-workflow-box">
                          <h3 className="heading">{data && data.feature2.title2}</h3>
                          <p>{data && data.feature2.description2}</p>
                        </div>
                        <div className="br-workflow-box">
                          <h3 className="heading">{data && data.feature2.title3}</h3>
                          <p>{data && data.feature2.description3}</p>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="br-img-animation">
                          <img className="img-responsive wow animate__animated animate__flipInY"  data-wow-duration="1s" src={data && data.feature2.image} alt="mobile" loading="lazy"/>
                          <div className="br-animate-box"></div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="br-workflow-box br-workflow-box-reverse">
                          <h3 className="heading">{data && data.feature2.title5}</h3>
                          <p>{data && data.feature2.description5}</p>
                        </div>
                        <div className="br-workflow-box br-workflow-box-reverse">
                          <h3 className="heading">{data && data.feature2.title6}</h3>
                          <p>{data && data.feature2.description6}</p>
                        </div>
                        <div className="br-workflow-box br-workflow-box-reverse">
                          <h3 className="heading">{data && data.feature2.title7}</h3>
                          <p>{data && data.feature2.description7}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>

                <Tab eventKey="adminpanel" title="ADMIN PANEL">
                  <div className="zip-feature-body">
                    <div className="row align-items-center">
                      <div className="col-lg-4 text-right">
                        <div className="br-workflow-box">
                          <h3 className="heading">{data && data.feature3.title1}</h3>
                          <p>{data && data.feature3.description1}</p>
                        </div>
                        <div className="br-workflow-box">
                          <h3 className="heading">{data && data.feature3.title2}</h3>
                          <p>{data && data.feature3.description2}</p>
                        </div>
                        <div className="br-workflow-box">
                          <h3 className="heading">{data && data.feature3.title3}</h3>
                          <p>{data && data.feature3.description3}</p>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="br-img-animation">
                          <img className="img-responsive wow animate__animated animate__flipInY"  data-wow-duration="1s" src={data && data.feature3.image} alt="mobile" loading="lazy"/>
                          <div className="br-animate-box"></div>
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="br-workflow-box br-workflow-box-reverse">
                          <h3 className="heading">{data && data.feature3.title5}</h3>
                          <p>{data && data.feature3.description5}</p>
                        </div>
                        <div className="br-workflow-box br-workflow-box-reverse">
                          <h3 className="heading">{data && data.feature3.title6}</h3>
                          <p>{data && data.feature3.description6}</p>
                        </div>
                        <div className="br-workflow-box br-workflow-box-reverse">
                          <h3 className="heading">{data && data.feature3.title7}</h3>
                          <p>{data && data.feature3.description7}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>

            <div className="col-lg-12 text-center">
              <button onClick={() => dispatch(openPopup())} className="default-btn">Get In Touch</button>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
